import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {Message} from '../models/message.model';
import {MessageType} from '../constants/message-type.constant';

/**
 * This service manage all message broadcast in the system. It's based on Subject Observable.
 */
@Injectable({providedIn: 'root'})
export class MessageService {
  // ovvio che è any, da cambiare
  private bus: Subject<Message | any>;

  constructor() {
    // Observable sources
    this.bus = new Subject<Message>();
  }

  /**
   * Subscribe a function to receive all new messages
   * @param callMeOnNewMessage
   */
  public subscribe(callMeOnNewMessage: any) {
    this.bus.subscribe(callMeOnNewMessage);
  }

  /**
   * Return a observable
   */
  public getObserver(): Observable<Message> {
    return this.bus.asObservable();
  }

  /**
   * Throw a message to observer and check as managed the message
   * @param m
   */
  public throwMessage(m: Message) {
    if (!(m instanceof Message)) {
      this.manageJSError(m);
      return;
    }
    m.managed();
    this.bus.next(m);
  }

  /**
   * Throw an unmanaged message to the observer (for developers only)
   * @param m
   */
  public throwUnmanagedMessage(m: Message) {
    this.bus.next(m);
  }

  /**
   * This method simplify send message
   * @param text the content of message
   * @param i18nPlaceHolder
   * @param title the title of message
   * @param type the type of messages
   */
  public throwMessageSimple(
    text: string,
    type: MessageType = MessageType.INFO_MESSAGE,
    i18nPlaceHolder?: any,
    title?: string,
  ) {
    // log.debug('throw message simple', text, title, type);
    const mex: Message = new Message();
    mex.message = text;
    mex.title = title;
    mex.type = type;
    mex.i18NPlaceHolder = i18nPlaceHolder;
    mex.managed();
    this.bus.next(mex);
  }

  public throwConfirmMessage(title: string = 'MESSAGE.TITLE.CONFIRM', message: string = 'MESSAGE_SENT', callback?: Observable<any>) {
    // log.debug('throw message simple', text, title, type);
    const mex: Message = new Message();
    mex.message = message;
    mex.title = title;
    mex.type = MessageType.CONFIRM_MESSAGE;
    mex.managed();
    this.bus.next({mex: mex, callback: callback});
  }

  /**
   * this method manage the case you sent a js error to this service for error
   */
  private manageJSError(err: any) {
    this.throwMessageSimple(err.message, MessageType.ERROR_BLOCK, undefined, 'ERRORE IMPREVISTO');
  }
}
